import { Fragment } from 'react';
import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const { Text, FlexPane, Dialog, ScrollPane } = MojitoPresentation.Components;
const { GridCell, GridPane } = MojitoPresentation.Components.GridLayout;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

const GRID_HEADER_NAMES = ['SELECTION_HEADER_NAME', 'ODDS_HEADER_NAME'];
const COLUMNS_NUMBER = 2;

export default class CombinationOddsPopup extends UIViewImplementation {
    constructor(props) {
        super(props);

        this.state = {
            isScrolled: false,
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    renderPopupContent() {
        return (
            <FlexPane config={this.config.contentContainer}>{this.renderContentGrid()}</FlexPane>
        );
    }

    handleScroll(scrollInfo) {
        const { scrollPosition } = scrollInfo;

        if (scrollPosition > 0 && !this.state.isScrolled) {
            this.setState({ isScrolled: true });
        } else if (scrollPosition <= 0) {
            this.setState({ isScrolled: false });
        }
    }

    renderContentGrid() {
        const gridContent = this.mappedOddsLines();

        const { combinationOddsGrid, boxShadow } = this.config;
        const gridHeaderConfig = this.state.isScrolled
            ? { style: { ...combinationOddsGrid.style, boxShadow } }
            : combinationOddsGrid;

        return (
            // These two GridPanes will be changed to one when GridPane will have scroll content opportunity
            <>
                <GridPane
                    repeatedColumnsNum={COLUMNS_NUMBER}
                    key={this.state.isScrolled}
                    config={gridHeaderConfig}
                >
                    {this.renderHeaderGridRow(GRID_HEADER_NAMES)}
                </GridPane>
                <ScrollPane config={this.config.scrollPane} onScroll={this.handleScroll}>
                    <GridPane
                        repeatedColumnsNum={COLUMNS_NUMBER}
                        config={this.config.combinationOddsGrid}
                    >
                        {this.generateListOfGridRows(gridContent)}
                    </GridPane>
                </ScrollPane>
            </>
        );
    }

    mappedOddsLines() {
        return this.props.oddsLines.map(({ odds, selectionIds }) => ({
            selection: this.mappedPartsByRunnerNumbers(selectionIds),
            odds,
        }));
    }

    mappedPartsByRunnerNumbers(selectionIds) {
        const selections = this.props.parts.reduce((acc, part) => {
            acc[part.selectionId] = part.number;
            return acc;
        }, {});
        return selectionIds.map(id => `${selections[id]}`).join(this.config.delimiterSymbol);
    }

    renderHeaderGridRow(listOfHeaderNames) {
        return listOfHeaderNames.map((name, index) => {
            const resolvedString = this.resolveString(
                `$BETSLIP.COMBINATION_ODDS_GRID_HEADER_NAMES.${name}`
            );
            const cellData = {
                key: name,
                text: resolvedString,
                cellNumber: index + 1,
                configProperty: 'gridHeader',
            };

            return this.renderContentGridCell(cellData);
        });
    }

    generateListOfGridRows(listOfData) {
        return listOfData.map(item => this.renderContentGridRow(item));
    }

    renderContentGridRow(rowData) {
        const listOfDataKeys = Object.keys(rowData);
        const rowKey = `${rowData.selection}-${rowData.odds}`;

        return (
            <Fragment key={rowKey}>
                {listOfDataKeys.map((key, index) => {
                    const cellData = {
                        key: `${rowData[key]}-${rowData.selection}-${rowData.odds}`,
                        text: rowData[key],
                        cellNumber: index + 1,
                        configProperty: 'gridText',
                    };

                    return this.renderContentGridCell(cellData);
                })}
            </Fragment>
        );
    }

    renderContentGridCell({ key, text = '', configProperty = '', cellNumber }) {
        const textConfig = {
            ...this.config[configProperty],
            style: {
                ...this.config[configProperty].style,
                textAlign: cellNumber === COLUMNS_NUMBER ? 'right' : 'left',
            },
        };

        return (
            <GridCell key={key}>
                <Text config={textConfig}>{text}</Text>
            </GridCell>
        );
    }

    renderDialogHeader() {
        return (
            <Text config={this.config.popupHeaderTitle} class="ta-CombinationOddsPopupHeader">
                {this.props.headerTitle}
            </Text>
        );
    }

    render() {
        const headerTitle = this.props.headerTitle;

        return (
            <Dialog
                isOpen={this.props.isVisible}
                header={headerTitle}
                headerComponent={this.renderDialogHeader()}
                config={this.config.dialog}
                onClickOutside={this.props.onClickOutside}
                onCloseButtonClick={this.props.onClickOutside}
                class="ta-CombinationOddsPopup"
            >
                {this.renderPopupContent()}
            </Dialog>
        );
    }
}
